import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7103976d"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "ButtonSave__Default button",
  ref: "base"
}
const _hoisted_2 = { class: "ButtonSave__Text" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Label button")
const _hoisted_4 = { class: "ButtonSave__Hover" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Label button")
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ButtonSave__Saved__Background" }, null, -1))
const _hoisted_7 = { class: "ButtonSave__Saved" }
const _hoisted_8 = {
  key: 0,
  class: "ButtonSave__Saved__Inner",
  ref: "saved"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "ButtonSave__Saved__Icon",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M7 11.6522L11.2254 16L19 8",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.type), {
    to: _ctx.to,
    disabled: _ctx.loading || _ctx.disabled,
    class: _normalizeClass(["ButtonSave button", { 'moving': _ctx.moving, 'loading': _ctx.loading || _ctx.disabled, 'saved': _ctx.saved, 'completed': (_ctx.savedCompleted && _ctx.saved) }])
  }, {
    default: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, [
          _renderSlot(_ctx.$slots, "default", {}, () => [
            _hoisted_3
          ], true)
        ]),
        _createElementVNode("span", _hoisted_4, [
          _renderSlot(_ctx.$slots, "default", {}, () => [
            _hoisted_5
          ], true)
        ])
      ], 512),
      _hoisted_6,
      _createElementVNode("span", _hoisted_7, [
        _createVNode(_Transition, {
          name: "saved",
          onEnter: _ctx.onEnterSaved,
          onBeforeLeave: _ctx.onBeforeUnsaved,
          onLeave: _ctx.onUnsaved
        }, {
          default: _withCtx(() => [
            (_ctx.saved)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                  _renderSlot(_ctx.$slots, "saved", {}, undefined, true)
                ], 512))
              : _createCommentVNode("", true)
          ]),
          _: 3
        }, 8, ["onEnter", "onBeforeLeave", "onLeave"]),
        _hoisted_9
      ])
    ]),
    _: 3
  }, 8, ["to", "disabled", "class"]))
}